export default __webpack_public_path__ + "static/media/1819 cutlery top.4974cdaf.png";